//
import { RTableHeaders } from '@/components/reusable_components/next'

//
export default new RTableHeaders('PchPurchaseInvoiceHeaders', 
    {
        text: '#',
        value: 'id',
    },
    {
        text: 'folio',
        value: 'invoice_number',
    },
    {
        text: 'rut',
        value: 'pch_provider_rut',
    },
    {
        text: 'proveedor',
        value: 'pch_provider_business_name',
    },
    {
        text: 'neto',
        value: 'new_subtotal',
        align: 'right',
        format: 'currency',

    },
    {
        text: 'iva',
        value: 'iva',
        align: 'right',
        format: 'currency',
    },
    {
        text: 'total',
        value: 'total',
        align: 'right',
        format: 'currency',
        classes: 'accent lighten-3',
    },
    {
        text: 'condicion de pago',
        value: 'pch_payment_condition_type',
        align: 'center',
        component: {
        	type: 'chip-label',
        	props: {
        		small: true,
        	}
        },
    },
    {
        text: 'emision',
        value: 'emission_date',
        align: 'right',
        format: 'date',
    },
)
